import { render } from "./AssignEvent.vue?vue&type=template&id=22c226ee"
import script from "./AssignEvent.vue?vue&type=script&lang=js"
export * from "./AssignEvent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__